<template>
    <div class="exam-detail yx-start" ref="examDetail">
        <exam-header></exam-header>
        <div class="cards app-width auto-grow" v-if="currentPaper!==null">
            <div class="paper">
                <div class="xy-center font-size22 font-medium" style="color: #2F3134">
                    {{ ExamName }}
                </div>
                <div class="paper-info font-size14 c-72777F">
                    <div>试卷总分:{{ currentPaper.TotalScore }}分</div>
                    <div>考试时间:{{ parseInt(currentPaper.ExamTime) === 0 ? '不限时长' : currentPaper.ExamTime + '分钟' }}</div>
                    <div>试题总量:{{ currentPaper.SubjectNum }}题</div>
                </div>
                <div style="color: #ff0000; font-size: 15px; font-weight: 500; margin: 20px 0" v-if="isShowTips">
                    {{tips}}
                </div>
                <div class="answer-box">
                    <div v-for="(spin, index) in dataList" :key="index">
                        <div class="spin-title font-size18 font-medium">
                            {{ spin.bigNo }}、{{ spin.Content }}（共{{ spin.SubjectNum }}题，合计{{ spin.SubjectTypeScore }}分）
                        </div>
                        <div v-for="(orginObj,index) in spin.ExamPaperSubjectData" :key="index">
                            <!-- 题干 -->
                            <question :orgin-obj="orginObj"></question>
                            <!-- 单选题 -->
                            <div class="sigleSelect" v-if="orginObj.SubjectType === 1">
                                <div class="topics">
                                    <div class="topicItem jf" v-for="(singleItem,index2) in orginObj.SubjectAnswerData"
                                         :key="index2">
                                        <div class="options xy-center cursor no-shrink" :class="{'singleActive' : singleItem.rankStyle,
                                             'makeRightStyle' : singleItem.origlRight,
                                             'isErrorActive' : singleItem.userIsErrStyle,
                                             'disabled': isHaveSubmit
                                             }" @click="selectSingleAnswer(singleItem,orginObj)">
                                            {{ opTab[index2] }}
                                        </div>
                                        <div class="content font-size14 cursor auto-grow"
                                             @click="selectSingleAnswer(singleItem,orginObj)"
                                             v-html="singleItem.Content">
                                        </div>
                                    </div>
                                </div>
                                <div v-if="showAnwser" class="parsingBox">
                                    <div class="showAnswerText xy-between">
                                        <div class="lfet jf">
                                            <div class="right jf">
                                                答案：
                                                <div class="c-00B37C font-size18"
                                                     v-for="(singleItem,index2) in orginObj.SubjectAnswerData"
                                                     :key="index2">
                                                    <div class="" v-if="singleItem.IsRight">
                                                        <div>{{ opTab[index2] }}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="your jf">
                                                回答：
                                                <div v-if="orginObj.userIsRight" class="c-00B37C font-size18">
                                                    正确
                                                </div>
                                                <div v-else-if="orginObj.haveDo" class="c-F33737 font-size18">
                                                    错误
                                                </div>
                                                <div v-else class="c-F33737 font-size18">
                                                    未做
                                                </div>
                                                <!-- <div v-else class="c-F33737 font-size18">正确</div> -->
                                            </div>
                                        </div>
                                        <div class="right">
                                            <!-- 纠错 -->
                                        </div>
                                    </div>
                                    <answer-parser :analysis="orginObj.Analysis"></answer-parser>
                                </div>
                            </div>
                            <!-- 多选题 -->
                            <div class="multiSelect " v-else-if="orginObj.SubjectType === 2">
                                <div class="topics">
                                    <div class="topicItem jf" v-for="(singleItem,index2) in orginObj.SubjectAnswerData"
                                         :key="index2">
                                        <div class="options xy-center cursor multiple no-shrink" :class="{'singleActive' : singleItem.rankStyle,
                                             'makeRightStyle'  : singleItem.origlRight,
                                             'isErrorActive' : singleItem.userIsErrStyle,
                                             'disabled': isHaveSubmit
                                             }" @click="selectSomeAnswer(singleItem,orginObj)">
                                            {{ opTab[index2] }}
                                        </div>
                                        <div class="content font-size14 cursor auto-grow"
                                             v-html="singleItem.Content"
                                             @click="selectSomeAnswer(singleItem,orginObj)"
                                        ></div>
                                    </div>
                                </div>
                                <div>
                                    <div v-if="showAnwser" class="parsingBox">
                                        <div class="showAnswerText xy-between">
                                            <div class="lfet jf full-width">
                                                <div class="right jf">
                                                    答案：
                                                    <div class="c-00B37C font-size18"
                                                         v-for="(singleItem,index2) in orginObj.SubjectAnswerData"
                                                         :key="index2">
                                                        <div class="" v-if="singleItem.IsRight">
                                                            <div>{{ opTab[index2] }}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="your jf">
                                                    回答：
                                                    <div v-if="orginObj.userIsRight" class="c-00B37C font-size18">
                                                        正确
                                                    </div>
                                                    <div v-else-if="orginObj.haveDo" class="c-F33737 font-size18">
                                                        错误
                                                    </div>
                                                    <div v-else class="c-F33737 font-size18">
                                                        未做
                                                    </div>
                                                    <!-- <div v-else class="c-F33737 font-size18">正确</div> -->
                                                </div>
                                            </div>
                                            <div class="right">
                                                <!-- 纠错 -->
                                            </div>
                                        </div>
                                        <answer-parser :analysis="orginObj.Analysis"></answer-parser>
                                    </div>
                                    <div v-else class="notParsingBox">

                                    </div>
                                </div>
                            </div>
                            <!-- 填空题 -->
                            <div class="fillBlank" v-else-if="orginObj.SubjectType === 3">
                                <div class="fillBlankItem" v-for="(singleItem,index2) in orginObj.SubjectAnswerData"
                                     :key="index2">
                                    <div class="font-size14 c-333333 fillBlanktext">填空{{ index2 + 1 }}</div>
                                    <div class="fillBlankField" :class="{'disabled': isHaveSubmit}">
                                        <el-input v-if="!isHaveSubmit" resize="none" :readonly="isHaveSubmit"
                                                  v-model="singleItem.rankStyle"
                                                  @input="(val) => onInput(orginObj, singleItem)" rows="1" autosize
                                                  type="textarea" placeholder="请在此输入您的答案"></el-input>
                                        <el-input v-else readonly v-model="singleItem.rankStyle" rows="1" autosize
                                                  type="textarea" placeholder="未作答"></el-input>
                                    </div>
                                </div>
                                <div v-if="false" class="confrimBtn xy-center font-size16 cursor" @click="save">
                                    保存
                                </div>
                                <div v-if="showAnwser" class="parsingBox">
                                    <div class="showAnswerText xy-between">
                                        <div class="lfet jf full-width">
                                            <div class="right full-width">
                                                <div style="margin-bottom:20px;color:#00B37C">正确答案：</div>
                                                <div v-for="(singleItem,index2) in orginObj.SubjectAnswerData"
                                                     :key="index2"
                                                    style="padding-left: 20px"
                                                     class="xy-center"
                                                >
                                                    <div class="no-shrink">填空{{index2+1}}：</div>
                                                    <div v-if="singleItem.Content" v-html="singleItem.Content"
                                                        class="auto-grow"
                                                    ></div>
                                                    <div v-else>无</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="right">
                                            <!-- 纠错 -->
                                        </div>
                                    </div>
                                    <answer-parser :analysis="orginObj.Analysis"></answer-parser>
                                </div>
                            </div>
                            <!-- 判断题 -->
                            <div class="judgeTopic" v-else-if="orginObj.SubjectType === 4">
                                <div class="topics">
                                    <div class="topicItem jf" v-for="(singleItem,index2) in orginObj.SubjectAnswerData"
                                         :key="index2">
                                        <div class="options xy-center cursor multiple " :class="{'singleActive' : singleItem.rankStyle,
                                             'makeRightStyle' : singleItem.origlRight,
                                             'isErrorActive' : singleItem.userIsErrStyle,
                                             'disabled': isHaveSubmit
                                        }" @click="selectSingleAnswer(singleItem,orginObj)">
                                            {{ opTab[index2] }}
                                        </div>
                                        <div class="content font-size14 cursor"
                                             v-html="singleItem.Content"
                                             @click="selectSingleAnswer(singleItem,orginObj)"
                                        ></div>
                                    </div>
                                </div>
                                <div>
                                    <div v-if="showAnwser" class="parsingBox">
                                        <div class="showAnswerText xy-between">
                                            <div class="lfet jf">
                                                <div class="right jf">
                                                    正确答案：
                                                    <div class="c-00B37C font-size18"
                                                         v-for="(singleItem,index2) in orginObj.SubjectAnswerData"
                                                         :key="index2">
                                                        <div class="" v-if="singleItem.IsRight">
                                                            <div>{{ opTab[index2] }}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="your jf">
                                                    您的答案：
                                                    <!-- <div class="font-size18"
                                                         v-for="(singleItem,index2) in orginObj.SubjectAnswerData"
                                                         :class="[orginObj.userIsRight ? 'c-00B37C' : 'c-F33737']"
                                                         :key="index2">
                                                        <div class="" v-if="singleItem.rankStyle">
                                                            <div>{{ opTab[index2]  }}</div>
                                                        </div>

                                                    </div> -->
                                                    <div class="font-size18"
                                                         :class="[orginObj.userIsRight ? 'c-00B37C' : 'c-F33737']">
                                                        <div v-if="orginObj.SubjectAnswerData[0].rankStyle">
                                                            <div>{{ opTab[0] }}</div>
                                                        </div>
                                                        <div v-else-if="orginObj.SubjectAnswerData[1].rankStyle">
                                                            <div>{{ opTab[1] }}</div>
                                                        </div>
                                                        <div v-else>
                                                            <div>未作答</div>
                                                        </div>

                                                    </div>
                                                    <!-- <div v-else class="c-F33737 font-size18">正确</div> -->
                                                </div>
                                            </div>
                                            <div class="right">
                                                <!-- 纠错 -->
                                            </div>
                                        </div>
                                        <answer-parser :analysis="orginObj.Analysis"></answer-parser>
                                    </div>
                                    <div v-else class="notParsingBox">

                                    </div>
                                </div>
                            </div>
                            <!-- 简答题 -->
                            <div class="shortAnswer fillBlank" v-else-if="orginObj.SubjectType === 5">
                                <div class="fillBlankItem" v-for="(singleItem,index2) in orginObj.SubjectAnswerData"
                                     :key="index2">
                                    <div class="fillBlankField" style="margin-top: 40px"
                                         :class="{'disabled': isHaveSubmit}">
                                        <el-input v-if="!isHaveSubmit" resize="none" :readonly="isHaveSubmit"
                                                  v-model="singleItem.rankStyle"
                                                  @input="(val) => onInput(orginObj, singleItem)" rows="1" autosize
                                                  type="textarea" placeholder="请在此输入您的答案"></el-input>
                                        <el-input v-else readonly v-model="singleItem.rankStyle" rows="1" autosize
                                                  type="textarea" placeholder="未作答"></el-input>
                                    </div>
                                </div>
                                <div v-if="false" class="confrimBtn xy-center font-size16 cursor" @click="save">
                                    保存
                                </div>
                                <div v-if="showAnwser" class="parsingBox">
                                    <div class="showAnswerText xy-between">
                                        <div class="lfet jf full-width">
                                            <div class="right full-width">
                                                <div style="margin-bottom:20px;color:#00B37C">正确答案：</div>
                                                <div v-for="(singleItem,index2) in orginObj.SubjectAnswerData"
                                                     :key="index2">
                                                    <div v-if="singleItem.Content" v-html="singleItem.Content"></div>
                                                    <div v-else>无</div>
                                                </div>
                                            </div>

                                        </div>
                                        <div class="right">
                                            <!-- 纠错 -->
                                        </div>
                                    </div>
                                    <answer-parser :analysis="orginObj.Analysis"></answer-parser>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="answer-card yx-start no-shrink">
                <!--考生信息-->
                <div class="user-info yx-start font-size16">
                    <div class="title c-32353A font-medium">考生信息</div>
                    <div class="info-item"><label>账号：</label>
                        {{ $store.state.userInfo.UserName }}
                    </div>
                    <div class="info-item"><label>用户组：</label>
                        {{ $store.state.userInfo.LevelName | filterGroup($store.state.userInfo.OrganName) }}
                    </div>
                </div>
                <div class="countdown" v-if="examTime>-1 && isHaveSubmit===false">
                    <div class="title c-32353A font-medium">倒计时</div>
                    <div class="font-size18" style="margin-top: 10px;">{{ dateText }}</div>
                </div>
                <!--答题卡标题-->
                <div class="card-title full-width font-size14">
                    <div class="title c-32353A font-medium">答题卡</div>
                    <div class="xy-center ans-color">
                        <div v-show="showAnwser"><span style="background: #F33737"></span>错误</div>
                        <div v-show="showAnwser"><span style="background: #00B37C"></span>正确</div>
                        <div><span style="background: #256CF4"></span>已做</div>
                        <div><span style="background: #FFFFFF;border: 1px solid #E5E8EC;"></span>未做</div>
                    </div>
                </div>
                <div class="ans-list auto-grow">
                    <div v-for="(spin, index) in dataList" :key="index">
                        <div class="snap-title font-size16">{{ toChinesNum(index + 1) }}、{{ spin.Content }}</div>
                        <div class="ans-grid">
                            <div v-for="(orginObj,index2) in spin.ExamPaperSubjectData" :key="index2"
                                 class="ans-item xy-center cursor" :class="calcAnsClass(orginObj)">
                                <div @click="scrollToQues(orginObj.rankNum)">
                                    {{ orginObj.rankNum }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="submit" v-if="!isHaveSubmit">
                    <button @click="submitAnswer"><i class="iconfont icon-save" style="margin-right: 11px"></i>立即交卷
                    </button>
                </div>
                <!-- 提交试卷后的返回按钮 -->
                <div class="submit submit-back xy-between" v-else>
                    <button @click="goList">
                        {{ isSchool ? '试卷列表' : "考试列表" }}
                    </button>
                    <router-link v-if="isSchool" to="/personCenter/mark?type=paper" replace>
                        <button style="margin-left: 20px;background: #f1232d">做卷记录</button>
                    </router-link>
                    <router-link v-else to="/personCenter/exam" replace>
                        <button style="margin-left: 20px;background: #f1232d">我的考试</button>
                    </router-link>
                </div>
            </div>
        </div>
        <!-- 确定提交答案弹窗 -->
        <el-dialog :visible.sync="showSure" :show-close="false" :lock-scroll="false" custom-class="sure-dialog"
                   width="300px">
            <div class="text-center font-size14">
                <div v-if="dontDoCount > 0">
                    你还有<span style="color: #F7593B">{{ dontDoCount }}</span>题目未做，确定交卷吗？
                </div>
                <div v-else>
                    确定提交试卷？
                </div>
                <div style="margin-top: 30px" class="xy-between font-size14">
                    <button class="cancel-btn c-72777F btn-tap" @click="showSure=false">取消</button>
                    <button class="sure-btn btn-tap" @click="sureSubmit(false)" :disabled="submitting">确定</button>
                </div>
            </div>
        </el-dialog>
        <!-- 显示总分弹窗 -->
        <el-dialog :visible.sync="showScore" :show-close="false" custom-class="sure-dialog score-dialog" width="300px">
            <div class="text-center font-size14">
                <!-- 机构试卷不判断条件直接显示分数 -->
                <div v-if="isSchool" class="yx-center">
                    <div>试卷成绩</div>
                    <div class="score" style="margin-top: 20px">
                        本次考试得分为：<span class="font-size24">{{ totalScore }}</span> 分
                    </div>
                </div>
                <div v-else class="score">
                    <div v-if="showTotalState === scoreStates.showScore" class="font-size16 yx-center">
                        <div>本次考试客观题得分为：<span class="font-size24">{{ totalScore ? totalScore : 0 }}</span>分</div>
                    </div>
                    <div v-else-if="showTotalState === scoreStates.noTime" class="font-size16 yx-center">
                        <div>成绩将于{{ publishTime }}发布</div>
                    </div>
                    <div v-else-if="showTotalState === scoreStates.noScore">
                        <div>本次考试涉及主观题，因此不显示得分</div>
                    </div>
                    <div v-else-if="showTotalState === scoreStates.neverPub" class="font-size16 yx-center">
                        <div>查看当前分数请联系管理员</div>
                    </div>
                </div>

                <div style="margin-top: 30px" class="xy-between font-size14">
                    <button class="cancel-btn c-72777F btn-tap" @click="goList">返回列表</button>
                    <button class="sure-btn btn-tap" @click="viewAnswer">查看答案</button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    GetExamTestInfo,
    SubmitOnlineExam,
    GetMedicalPaperDetail,
    SubmitCommonExam
} from "@/api/course";
import {
    padZero, safeParseInt,
    toChinesNum
} from "@/utils";
import ExamHeader from "@/components/exam/ExamHeader";

import AutoSubmitExam from "./autoSubmitExam"
import scroll from "scroll"
import Question from "@/components/exam/Question";
import AnswerParser from "@/components/exam/AnswerParser";
import { ExamStatusHelper } from "@/mixins/examStatusHelper";
import doExamHelper from "@/mixins/doExamHelper";
import { examGetById } from "@/api/manage";

export default {
    name: "exam",
    components: {
        AnswerParser,
        Question,
        ExamHeader
    },
    mixins: [AutoSubmitExam, ExamStatusHelper, doExamHelper],
    data() {
        return {
            dataList: [],
            currentPaper: null,
            opTab: [], // 数字对应的字母 123 -> ABC
            isReadonly: false,
            dontDoCount: 0,
            showSure: false,
            finallyAnswer: null,
            totalScore: 0,
            showTotalState: false, // 是否显示总分
            showScore: false, // 显示分数弹窗
            publishTime: "", // 答案发布时间
            scorePublish: "", // 分数发布
            showAnwser: false, // 显示答案
            isCheckScore: "",
            MinExamTime: "0", // 最小考试时间
            isHaveSubmit: false, // 是否已提交
            examTime: -1, // 倒计时
            dateText: "", // 倒计时文本
            ExamName: "", // 考试名称
            isSchool: false, // 是否为机构试卷
            submitting: false, // 提交中
            examDetail: {}
        }
    },

    created() {
        if (!this.$store.getters.isLogin) {
            this.$router.replace("/?login=1")
            return
        }
        if (this.examUuid) {
            if (this.readExamSubmitted(this.examUuid)) {
                this.isHaveSubmit = true;
                window.alert("请从考试列表处重新开始考试")
                this.goList()
                return;
            }
        }
        this.isSchool = this.$route.query.type === "school";
        if (this.isSchool) {
            this.GetMedicalPaperDetail()
            this.ExamName = this.$route.query.paperName;
            let tabs = [];
            for (let i = 0; i < 24; i++) {
                tabs.push(String.fromCharCode(65 + i))
            }
            this.opTab = tabs;
        } else {
            this.publishTime = this.$route.query.publishTime;
            this.scorePublish = this.$route.query.scorePublish;
            this.isCheckScore = this.$route.query.isCheckScore;
            this.ExamName = this.$route.query.ExamName;
            this.MinExamTime = this.$route.query.MinExamTime;
            this.GetExamTestInfo()
            let tabs = [];
            for (let i = 0; i < 24; i++) {
                tabs.push(String.fromCharCode(65 + i))
            }
            this.opTab = tabs;
        };
        this.getExamDetail()
    },
    beforeDestroy() {
        clearInterval(this.intervalKey)
    },
    computed: {
        paperId() {
            return this.$route.query.id || this.$route.query.paperId
        },
        examUuid() {
            return this.$route.query.examUuid || "";
        },
        isShowTips ({ examDetail }) {
            return examDetail.IsFullScreen === 1 || examDetail.IsCopy === 1
        },
        tips ({ examDetail, isShowTips }) {
            if (isShowTips) {
                let msg = '温馨提示：'
                if (examDetail.IsFullScreen === 1) {
                    msg += '答题过程中请勿切屏，切屏后将自动交卷'
                }
                if (examDetail.IsCopy === 1) {
                    msg += '，本场考试禁止复制粘贴'
                }
                return msg
            }
            return ''
        }
    },
    methods: {
        // 机构试卷
        async GetMedicalPaperDetail() {
            try {
                const {
                    data
                } = await GetMedicalPaperDetail({
                    paperId: this.$route.query.paperId,
                    sourceType: 2,
                    paperName: this.$route.query.paperName,
                    classId: this.$route.query.classId,
                    categoryName: this.$route.query.ClassName,
                    examId: this.paperId
                });
                this.currentPaper = data.data
                this.addNo(data.data.SubjectTypeData);
                this.dataList = data.data.SubjectTypeData
                // 机构试卷无倒计时
                this.examTime = -1;
                this.currentPaper.ExamTime = "0"
            } catch (error) {
                console.log(error);
            }
        },
        toChinesNum,
        async GetExamTestInfo() {
            let id = this.paperId;
            let paperId = this.$route.query.paperId;
            try {
                const {
                    data
                } = await GetExamTestInfo({
                    examId: id,
                    examPaperId: paperId
                });
                this.currentPaper = data.data
                this.currentPaper.StartTime = new Date().getTime()
                this.currentPaper.ExamTime = this.$route.query.ExamTime;
                this.dataList = data.data.SubjectTypeData
                this.addNo(this.dataList);
                // 处理倒计时
                if (this.currentPaper.ExamTime === "0") {
                    this.examTime = -1; // 2小时
                } else {
                    this.examTime = this.currentPaper.ExamTime * 60;
                }
                this.dateText = this.getText(this.examTime)
                if (this.examTime > 0) {
                    this.intervalKey = setInterval(() => {
                        this.examTime--;
                        this.dateText = this.getText(this.examTime)
                        if (this.examTime <= 0) {
                            clearInterval(this.intervalKey)
                            this.examTimeEnd()
                        }
                        if (this.examTime === 10) {
                            console.log("考试即将结束")
                            this.$message({
                                message: "距离考试时间结束还有10秒",
                                type: "warning"
                            });
                        }
                    }, 1000)
                }
            } catch (err) {
                console.log(err);
                this.$message("服务器繁忙，请稍后再试！");
            }
        },
        // 保存试卷,暂未调用，搁置
        save() {
            let answer = this.getAnswer(this.dataList)
            console.table(answer)
        },
        // 添加序号
        addNo(dataList) {
            let no = 1;
            for (let i = 0; i < dataList.length; i++) {
                dataList[i].bigNo = toChinesNum(i + 1);
                for (let j = 0; j < dataList[i].ExamPaperSubjectData.length; j++) {
                    let question = dataList[i].ExamPaperSubjectData[j]
                    question.rankNum = no++
                    this.resetAnswerRank(question)
                }
            }
        },
        // 计算答题卡的class
        calcAnsClass(ques) {
            return {
                "has-ans": ques.haveDo,
                right: ques.userIsRight,
                error: [1, 2, 4].includes(ques.SubjectType) && !ques.userIsRight && ques.haveDo && this.showAnwser
            }
        },
        onInput(orginObj, item) {
            if (item.rankStyle) {
                orginObj.haveDo = true;
            } else {
                orginObj.haveDo = false;
            }
        },
        // 单选 和判断
        selectSingleAnswer(val, orginObj) {
            if (this.isHaveSubmit) {
                console.log("已做过");
                return
            }
            orginObj.haveDo = true
            orginObj.SubjectAnswerData.forEach(v => {
                if (v.AnswerId === val.AnswerId) {
                    v.rankStyle = 1
                    orginObj.haveDo = true
                } else {
                    v.rankStyle = 0
                }
            })
            this.$forceUpdate()
        },
        // 多选
        selectSomeAnswer(val, orginObj) {
            if (this.isHaveSubmit) {
                console.log("已做过");
                return
            }
            if (val.rankStyle) {
                val.rankStyle = 0
            } else {
                val.rankStyle = 1
            }
            orginObj.haveDo = false
            if (orginObj && orginObj.SubjectAnswerData) {
                orginObj.SubjectAnswerData.forEach(v => {
                    if (v.rankStyle) {
                        orginObj.haveDo = true
                        return
                    }
                });
            }
            this.$forceUpdate()
        },
        // 获取答卷
        getAnswer(subjectList) {
            let answer = [];
            let subIdKey = "SubjectId"
            let answerKey = this.isSchool ? "AnswerContent" : "answer"
            subjectList.forEach(spin => {
                spin.ExamPaperSubjectData.forEach(v => {
                    if (v.SubjectType === 1) {
                        if (v.SubjectAnswerData) {
                            let obj = {}
                            obj[subIdKey] = v.SubjectId;
                            obj.SubjectType = v.SubjectType;
                            obj.SubjectTypeId = v.SubjectTypeId
                            obj[answerKey] = "";
                            // obj.name = v.subjectName
                            v.SubjectAnswerData.forEach(c => {
                                if (c.rankStyle) {
                                    obj[answerKey] = c.AnswerId
                                }
                            })
                            answer.push(obj)
                            return
                        }
                    } else if (v.SubjectType === 2) {
                        if (v.SubjectAnswerData) {
                            let obj = {}
                            obj[subIdKey] = v.SubjectId;
                            obj.SubjectType = v.SubjectType;
                            obj.SubjectTypeId = v.SubjectTypeId
                            obj[answerKey] = "";
                            // obj.name = v.subjectName
                            v.SubjectAnswerData.forEach(c => {
                                if (c.rankStyle) {
                                    if (obj[answerKey]) {
                                        obj[answerKey] = obj[answerKey] + "," + c.AnswerId
                                    } else {
                                        obj[answerKey] = c.AnswerId
                                    }
                                }
                            })
                            answer.push(obj)
                            return
                        }
                    } else if (v.SubjectType === 3) {
                        if (v.SubjectAnswerData) {
                            let obj = {}
                            obj[subIdKey] = v.SubjectId;
                            obj.SubjectType = v.SubjectType;
                            obj.SubjectTypeId = v.SubjectTypeId
                            obj[answerKey] = ""
                            v.SubjectAnswerData.forEach(c => {
                                let rankStyle = c.rankStyle || ""
                                obj[answerKey] = obj[answerKey] + c.AnswerId + "[-[-]-]" + rankStyle + "[-[-]-]"
                            })
                            answer.push(obj)
                            return
                        }
                    } else if (v.SubjectType === 4) {
                        if (v.SubjectAnswerData) {
                            let obj = {}
                            obj[subIdKey] = v.SubjectId;
                            obj.SubjectType = v.SubjectType;
                            obj.SubjectTypeId = v.SubjectTypeId
                            obj[answerKey] = ""
                            v.SubjectAnswerData.forEach(c => {
                                if (c.rankStyle) {
                                    obj[answerKey] = c.AnswerId
                                }
                            })
                            answer.push(obj)
                            return
                        }
                    } else if (v.SubjectType === 5) {
                        if (v.SubjectAnswerData) {
                            let obj = {}
                            obj[subIdKey] = v.SubjectId;
                            obj.SubjectType = v.SubjectType;
                            obj.SubjectTypeId = v.SubjectTypeId
                            obj[answerKey] = "";
                            // obj.name = v.content
                            v.SubjectAnswerData.forEach(c => {
                                if (c.rankStyle) {
                                    obj[answerKey] = c.rankStyle
                                }
                            })
                            answer.push(obj)
                            return
                        }
                    }
                });
            })
            return answer;
        },
        // 提交试卷
        submitAnswer() {
            if (this.$route.query.type === "school") {
                this.showSure = true;
            } else {
                if (this.MinExamTime > 0) {
                    let min = parseFloat(this.MinExamTime) * 60 * 1000; // 转为毫秒
                    let now = new Date().getTime();
                    if ((now - this.currentPaper.StartTime) < min) {
                        this.$alert(`${this.MinExamTime}分钟内不能交卷`, "提示", {
                            lockScroll: false
                        });
                        return;
                    }
                }
                let ans = this.getAnswer(this.dataList)
                // 确定未做的题目数量
                let count = 0;
                this.dataList.forEach(spin => {
                    spin.ExamPaperSubjectData.forEach(orginObj => {
                        if (!orginObj.haveDo) {
                            count++
                        }
                    })
                })
                console.log(this.dataList, "dataList");
                this.finallyAnswer = ans;
                this.dontDoCount = count;
                this.showSure = true;
                console.log("未做的题目：", count)
            }
        },
        /**
             * 最终提交试卷
             * @param isAutoSubmit 是否为自动提交，如果是则不自动显示分数等
             */
        async sureSubmit(isAutoSubmit = false) {
            this.submitting = true;
            if (this.$route.query.type === "school") { // 做卷模式
                this.showSure = false;
                const loading = this.$loading({
                    lock: true,
                    text: "提交中",
                    spinner: "el-icon-loading",
                    background: "white"
                });
                let ans = this.getAnswer(this.dataList);
                console.log(ans, "ans");
                const {
                    data
                } = await SubmitCommonExam({
                    columnId: "0",
                    classId: safeParseInt(this.$route.query.classId),
                    paperName: this.$route.query.paperName,
                    categoryName: this.$route.query.ClassName,
                    examPaperId: this.$route.query.paperId,
                    startTime: this.$route.query.startTime,
                    examAnswer: JSON.stringify(ans),
                    sourceType: 2
                });
                let totalList = data.data
                let total = 0;
                totalList.forEach(e => {
                    if (e.Score) total = total + e.Score;
                })
                this.totalScore = total;
                loading.close()
                this.isHaveSubmit = true;

                if (!isAutoSubmit) {
                    this.showScore = true
                    this.showAnwser = false
                }
            } else { // 考试模式
                this.showSure = false;
                const loading = this.$loading({
                    lock: true,
                    text: "提交中",
                    spinner: "el-icon-loading",
                    background: "white"
                });
                let ans = this.getAnswer(this.dataList);
                console.log(ans, "ans");
                const {
                    data
                } = await SubmitOnlineExam({
                    examAnswer: JSON.stringify(ans),
                    examId: this.paperId
                });
                this.totalScore = data.data
                loading.close()
                clearInterval(this.intervalKey)

                this.showTotalState = this.getScoreState(this.totalScore, this.scorePublish, this.publishTime)

                this.isHaveSubmit = true;
                if (!isAutoSubmit) {
                    this.showScore = true
                    this.showAnwser = false
                }
            }
            this.submitting = false;
            if (this.examUuid) {
                this.writExamStatus(this.examUuid, true)
            }
        },
        // 查看答案
        viewAnswer() {
            if (this.isCheckScore === "0" || this.scorePublish === "1") {
                this.$message("当前考试已设置不能查看答案")
                return false
            }
            if (this.scorePublish === "2" && this.isCheckScore === "1") {
                let now = new Date().getTime();
                let publishTime = new Date(this.publishTime.replace(/-/g, "/"));
                publishTime = publishTime.getTime();
                if (parseInt(now) <= parseInt(publishTime)) {
                    this.$message(`请在${this.publishTime}后查看答案`)
                    return false
                }
            }
            this.correctPaper(this.dataList)
            this.showScore = false
            this.showAnwser = true
        },
        // 返回列表
        goList() {
            if (this.isSchool) {
                this.$router.replace("/question/organ?type=paper")
            } else {
                this.$router.replace("/exam")
            }
        },
        // 比较答案
        correctPaper(arr) {
            arr.forEach(vs => {
                vs.ExamPaperSubjectData.forEach(v => {
                    if (v.SubjectType === 1) {
                        if (v.SubjectAnswerData) {
                            v.SubjectAnswerData.forEach(c => {
                                if (c.rankStyle && !c.IsRight) {
                                    c.userIsErrStyle = true
                                }
                                if (c.IsRight) {
                                    c.origlRight = true
                                }
                                if (!v.userIsRight) {
                                    v.userIsRight = c.IsRight && c.rankStyle;
                                }
                            })
                        }
                        this.$forceUpdate()
                    }
                    //  多选
                    if (v.SubjectType === 2) {
                        if (v.SubjectAnswerData) {
                            let hasErr = false;
                            v.SubjectAnswerData.forEach(c => {
                                if (c.rankStyle && !c.IsRight) {
                                    c.userIsErrStyle = true
                                    hasErr = true; // 选了但这不是正确答案
                                }
                                if (c.IsRight && !c.rankStyle) {
                                    hasErr = true; // 这是正确答案，但是没选
                                }
                                if (c.IsRight) {
                                    c.origlRight = true
                                }
                            })
                            v.userIsRight = !hasErr;
                        }
                    }
                    // 判断
                    if (v.SubjectType === 4) {
                        if (v.SubjectAnswerData) {
                            v.SubjectAnswerData.forEach(c => {
                                if (c.rankStyle && !c.IsRight) {
                                    c.userIsErrStyle = true
                                }
                                if (c.IsRight) {
                                    c.origlRight = true
                                }
                                if (!v.userIsRight) {
                                    v.userIsRight = c.IsRight && c.rankStyle;
                                }
                            })
                        }
                    }
                })
            })
        },
        // 考试时间结束
        examTimeEnd() {
            this.sureSubmit(true)
                .then(() => {
                    return this.$alert("考试时间结束，系统已自动提交试卷", "考试提醒", {
                        confirmButtonText: "知道了"
                    })
                }).then(() => {
                    this.showScore = true
                    this.showAnwser = false
                })
        },
        // 倒计时文字
        getText(time) {
            let h = Math.floor(time / 3600) // 时
            let mm = Math.floor((time % 3600) / 60) // 分
            let m = time % 60 // 秒

            h = padZero(h, 2)
            mm = padZero(mm, 2)
            m = padZero(m, 2)
            return `${h}:${mm}:${m}`
        },
        scrollToQues(serial) {
            if (document.scrollingElement == null) return
            let que = document.getElementById("ques-" + serial)
            try {
                scroll.top(document.scrollingElement, que.offsetTop)
            } catch (e) {
                console.error(e)
                console.log("跳转试题失败，题号为：" + serial)
                console.log("----所有试题打印开始----")
                console.log(document.querySelectorAll(".topicNav"))
                console.log("----所有试题打印结束----")
            }
        },
        // 获取考试详情
        getExamDetail () {
            examGetById({
                id: this.paperId
            }).then(res => {
                if (res.IsCopy === 1) {
                    this.disabledCopyPaste()
                }
                this.examDetail = res
            })
        }
    }
}

</script>

<style scoped lang="less">
.exam-detail {
    min-height: 100vh;

    .disabled {
        cursor: not-allowed;
    }

    .cards {
        align-items: start;
        display: flex;
        margin-top: 100px;
        position: relative;
        margin-bottom: 30px;

        .paper {
            flex-grow: 1;
            background: #FFFFFF;
            border-radius: 12px;
            padding: 30px;

            .paper-info {
                margin-top: 10px;
                display: flex;
                justify-content: center;

                div {
                    margin-left: 160px;
                }

                div:first-child {
                    margin-left: 0;
                }
            }

            .answer-box {
                .spin-title {
                    background: #F4F5F6;
                    padding-left: 30px;
                    padding-top: 10px;
                    padding-bottom: 10px;
                    line-height: 1.5;
                    margin-top: 21px;
                }

                .topics {
                    margin-top: 32px;
                    margin-left: 51px;
                    margin-right: 31px;

                    .topicItem {
                        margin-bottom: 20px;
                        ::v-deep img {
                            max-width: 100%;
                        }

                        .options {
                            width: 30px;
                            height: 30px;
                            border-radius: 50%;
                            background: #FFFFFF;
                            border: 1px solid #E5E8EC;
                            margin-right: 10px;
                        }

                        .singleActive {
                            background-color: #256CF4;
                            color: white;
                        }

                        .makeRightStyle {
                            background-color: #00B37C;
                            color: white;
                        }

                        .isErrorActive {
                            background-color: #F7593B;
                            color: white;
                        }

                        .multiple {
                            border-radius: 6px;
                        }
                    }
                }

                .multiSelect .topics {
                    .makeRightStyle {
                        background-color: #00B37C;
                        color: white;
                        border: 1px #F7593B solid;
                    }

                    .singleActive.makeRightStyle {
                        background-color: #00B37C;
                        color: white;
                        border: 1px #00B37C solid;;
                    }
                }

                .parsingBox {
                    margin-top: 60px;
                    width: 100%;
                    border-radius: 8px;
                    border: 1px solid #E5E8EC;
                    min-height: 100px;
                    padding: 30px;
                    box-sizing: border-box;
                    font-size: 14px;

                    .showAnswerText {
                        .lfet {
                            .your {
                                margin-left: 70px;
                            }
                        }
                    }

                    .parsing {
                        .tit {
                            margin: 30px 0 20px 0;

                            .cyc {
                                width: 5px;
                                height: 5px;
                                border-radius: 50%;
                                background: #256CF4;
                                margin-right: 8px;
                            }
                        }
                    }
                }

                .notParsingBox {
                    width: 100%;
                    border-radius: 8px;
                    // min-height: 218px;
                }

                .fillBlank {

                    .fillBlankItem {
                        margin-left: 51px;
                        margin-right: 31px;

                        .fillBlanktext {
                            margin: 30px 0 20px 0;
                        }

                        ::v-deep .el-textarea__inner {
                            min-height: 100px !important;
                        }
                    }

                    .confrimBtn {
                        width: 120px;
                        height: 40px;
                        background: #EEF4FF;
                        border-radius: 8px;
                        border: 1px solid #256CF4;
                        color: #256CF4;
                        margin: 40px 0;
                    }
                }
            }
        }

        .answer-card {
            position: sticky;
            top: 100px;
            left: 0;
            width: 320px;
            height: calc(100vh - 130px); // headler70px + 上下边距共60px = 130px
            background: #FFFFFF;
            border-radius: 12px;
            margin-left: 30px;

            .remake {
                width: 90px;
                height: 36px;
                background: #F9F9FA;
                border-radius: 8px;
                border: 1px solid #E5E8EC;
                color: #72777F;
            }

            .title {
                font-family: PingFangSC-Medium, PingFang SC;
                line-height: 18px;
                padding-left: 4px;
                font-size: 16px;
                border-left: 4px solid #256CF4;
            }

            .user-info {
                box-sizing: border-box;
                width: 100%;
                padding: 24px 21px 30px;
                border-bottom: 1px solid #F1F2F6;

                .info-item {
                    margin-top: 20px;

                    label {
                        width: 70px;
                        font-size: 16px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #72777F;
                        line-height: 22px;
                    }
                }
            }

            .countdown {
                width: 100%;
                padding: 23px 19px 21px 24px;
                border-bottom: 1px solid #F1F2F6;
            }

            .card-title {
                box-sizing: border-box;
                padding: 23px 19px 2px 24px;

                .ans-color {
                    margin-top: 13px;

                    div {
                        margin-left: 30px;
                    }

                    div:first-child {
                        margin-left: 0
                    }

                    span {
                        width: 10px;
                        height: 10px;
                        border-radius: 2px;
                        background: #F33737;
                        display: inline-block;
                        margin-right: 4px;
                    }
                }
            }

            .submit {
                box-sizing: border-box;
                width: 100%;
                box-shadow: 0px 2px 20px 0px rgba(229, 232, 236, 0.65);
                padding: 15px 20px;

                a {
                    display: contents;
                }

                button {
                    border: unset;
                    background: #256CF4;
                    border-radius: 8px;
                    width: 100%;
                    height: 40px;
                    color: white;
                    cursor: pointer;
                }

                button:active {
                    opacity: 0.8;
                }
            }

            .ans-list {
                overflow-y: auto;
                width: 100%;
                padding-bottom: 20px;

                .snap-title {
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    line-height: 20px;
                    margin: 20px;
                }

                .ans-grid {
                    justify-content: center;
                    display: grid;
                    grid-template-columns: repeat(5, 1fr);
                    gap: 20px;
                    padding: 0 19px;
                    justify-items: center;

                    .ans-item {
                        width: 100%;
                        height: 0;
                        position: relative;
                        background: #FFFFFF;
                        padding-bottom: 100%;
                        border-radius: 8px;
                        border: 1px solid #E5E8EC;
                        font-size: 16px;
                        color: #868EA1;

                        &.has-ans {
                            background: #256CF4;
                            border: 1px solid #256CF4;
                            color: white;
                        }

                        &.right {
                            background: rgb(0, 179, 124);
                            border: 1px solid rgb(0, 179, 124);
                            color: white;
                        }

                        &.error {
                            background: #F33737;
                            border: 1px solid #F33737;
                            color: white;
                        }

                        div {
                            position: absolute;
                            left: 0;
                            top: 0;
                            width: 100%;
                            height: 100%;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }
                    }

                    .ans-item.right {
                        background: #00B37C;
                        border: 1px solid #00B37C;
                        color: white;
                    }

                    .ans-item.error {
                        background: #F7593B;
                        border: 1px solid #F7593B;
                        color: white;
                    }
                }

                &::-webkit-scrollbar {
                    width: 6px;
                }

                &::-webkit-scrollbar-track {
                    border-radius: 6px;
                }

                &::-webkit-scrollbar-thumb {
                    border-radius: 6px;
                    background: #BAC0CA;
                }
            }
        }
    }

    ::v-deep .sure-dialog {
        border-radius: 10px;

        .el-dialog__header {
            display: none;
        }

        .el-dialog__body {
            padding: 30px;
        }

        .cancel-btn {
            width: 110px;
            height: 40px;
            border-radius: 22px;
            border: 1px solid #E5E8EC;
            background: white;
            cursor: pointer;
        }

        .sure-btn {
            width: 110px;
            height: 40px;
            background: linear-gradient(270deg, #5ABBFC 1%, #256CF4 100%);
            border-radius: 22px;
            color: white;
            border: unset;
            cursor: pointer;
        }
    }

    ::v-deep .score-dialog {
        .score {
            color: red;
        }
    }
    ::v-deep {
        p {
            margin-block-start: 0;
            margin-block-end: 0;
        }
    }
}

</style>
